import React from "react"
import PropTypes from "prop-types"
import TextField from "material-ui/TextField"
import FinddDatePicker from "../../../../components/common/FinddDatePicker"
import { blueGrey500 } from "material-ui/styles/colors"
let saveTimeout

const propTypes = {
    handleChange: PropTypes.func,
    handleIssuingAuthorityChange: PropTypes.func
}

export default class GovernmentDocInfo extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            title: "US Passport",
            issuingAuthority: "",
            documentNumber: "",
            expirationDate: "",
            image: ""
        }
        this.handleIssuingAuthorityChange = this.handleIssuingAuthorityChange.bind(this)
        this.handleDocumentNumberChange = this.handleDocumentNumberChange.bind(this)
        this.onImageDataChange = this.onImageDataChange.bind(this)
    }

    onImageDataChange(imageData) {
        const _this = this
        this.setState(
            {
                image: imageData
            },
            () => {
                this.triggerChange()
            }
        )
    }

    handleIssuingAuthorityChange(event) {
        const _this = this
        this.setState(
            {
                issuingAuthority: event.target.value
            },
            () => {
                this.triggerChange()
            }
        )
    }

    handleDocumentNumberChange(event) {
        const _this = this
        this.setState(
            {
                documentNumber: event.target.value
            },
            () => {
                this.triggerChange()
            }
        )
    }

    triggerChange() {
        if (this.isValid()) {
            if (saveTimeout) {
                clearTimeout(saveTimeout)
            }

            const _this = this
            saveTimeout = setTimeout(function () {
                if (_this.props.handleChange) {
                    _this.props.handleChange(_this.getGovDoc())
                }
            }, 750)
        }
    }

    isValid() {
        if (this.state.title.length > 0 && this.state.issuingAuthority.length > 0 && this.state.documentNumber.length > 0 && this.state.image.length > 0) {
            return true
        }

        return false
    }

    getGovDoc() {
        return {
            DocumentTitle: "US Passport",
            IssuingAuthority: this.state.issuingAuthority,
            DocumentNumber: this.state.documentNumber,
            ExpirationDate: this.state.expirationDate,
            Image: this.state.image,
            ListType: 0,
            DocumentType: 1
        }
    }

    render() {
        return (
            <div className="GovernmentDocInfo" style={{ margin: 20 }}>
                <TextField floatingLabelText={"Issuing Authority"} value={this.state.issuingAuthority} onChange={this.handleIssuingAuthorityChange} style={{ width: "100%" }} />
                <TextField floatingLabelText={"Document Number"} value={this.state.documentNumber} onChange={this.handleDocumentNumberChange} style={{ width: "100%" }} />
                <FinddDatePicker
                    hintText="Expiration Date (if any)"
                    cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                    firstDayOfWeek={0}
                />
                <UploadDocImage onImageDataChange={this.onImageDataChange} />
            </div>
        )
    }
}

GovernmentDocInfo.propTypes = propTypes
